import React, { useContext, useEffect } from 'react'
import { storageGet } from 'app/React/Helpers/StorageHelper'
import { validateSteps } from 'app/React/Helpers/StepHelper'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";
import {getCurrentPrice, getSecurityDeposit} from "app/React/Helpers/PriceHelper";

export default function StorageLoad({ children, cartItems }) {
  const {
    colorSettingId,
    configuratorUrl,
    currentEngineTransmission,
    currentLeasingPriceRanges,
    currentModelYear,
    currentVariant,
    dealerNumberOptions,
    engineTransmissions,
    identifier,
    isDealerConfigurator,
    hasConfiguration,
    modelYears,
    order,
    paymentTypes,
    variants,
    setCheckedChargings,
    setCheckedEquipmentRequirements,
    setColorImage,
    setCurrentEngineTransmission,
    setCurrentLeasingPriceRanges,
    setCurrentModelYear,
    setCurrentVariant,
    setIsStorageOrderHandled,
    setOrder,
    setValidSteps,
  } = useContext(ConfiguratorContext)

  const loadCurrentModelYear = function () {
    const storage_model_year_id = storageGet(identifier, 'currentModelYearId')

    if (typeof storage_model_year_id === 'string' || typeof storage_model_year_id === 'number') {
      for (let i = 0; i < modelYears.length; i++) {
        if (modelYears[i].id == storage_model_year_id) {
          setCurrentModelYear({ ...modelYears[i] })

          return modelYears[i]
        }
      }

      setCurrentModelYear({ ...modelYears[0] })

      return modelYears[0]
    }

    return currentModelYear
  }

  const loadCurrentVariant = function () {
    const storage_variant_id = storageGet(identifier, 'currentVariantId')

    if (typeof storage_variant_id === 'string' || typeof storage_variant_id === 'number') {
      for (let i = 0; i < variants.length; i++) {
        if (variants[i].id == storage_variant_id) {
          setCurrentVariant({ ...variants[i] })

          return variants[i]
        }
      }

      setCurrentVariant({ ...variants[0] })

      return variants[0]
    }

    return currentVariant
  }

  const loadCurrentEngineTransmission = function () {
    const storage_engine_transmission_id = storageGet(identifier, 'currentEngineTransmissionId')

    if (typeof storage_engine_transmission_id === 'string' || typeof storage_engine_transmission_id === 'number') {
      for (let i = 0; i < engineTransmissions.length; i++) {
        if (engineTransmissions[i].id == storage_engine_transmission_id) {
          setCurrentEngineTransmission({ ...engineTransmissions[i] })

          return engineTransmissions[i]
        }
      }

      setCurrentEngineTransmission({ ...engineTransmissions[0] })

      return engineTransmissions[0]
    }

    return currentEngineTransmission
  }

  const loadExtraEquipments = function () {
    const storage_order = storageGet(identifier, 'order')

    if (typeof storage_order === 'object' && storage_order !== null) {
      const newChecked = {}
      const extraEquipmentEntries = Object.entries(storage_order?.configuration?.extra_equipments ?? {})
      extraEquipmentEntries.forEach(entry => {
        entry[1].forEach((id) => {
          newChecked[id] = entry[0]
        })
      })

      setCheckedEquipmentRequirements(newChecked)
    }
  }

  const loadChargings = function () {
    const storage_order = storageGet(identifier, 'order')

    if (typeof storage_order === 'object' && storage_order !== null) {
      const newCheckedChargings = {}
      const chargingsEntries = Object.entries(storage_order?.configuration?.chargings ?? {})
      chargingsEntries.forEach(entry => {
        entry[1].forEach((id) => {
          newCheckedChargings[id] = entry[0]
        })
      })

      setCheckedChargings(newCheckedChargings)
    }
  }

  const loadOrder = function () {
    if (hasConfiguration) {
      order.payment_terms_accepted = false
      setOrder(order)

      const _configuratorUrl = configuratorUrl.charAt(configuratorUrl.length - 1) === '/' ? configuratorUrl.slice(0, -1) : configuratorUrl
      window.history.replaceState({}, document.title, _configuratorUrl + '/5')

      return order
    }

    let storage_order = storageGet(identifier, 'order')

    if (typeof storage_order === 'object' && storage_order !== null) {
      // Make sure paymenttype is valid
      if (Object.keys(paymentTypes).indexOf(storage_order.paymentType) < 0) {
        return false
      }

      storage_order.payment_terms_accepted = false
      storage_order.configuration.model_year = modelYears.find(modelYear => modelYear.id === storage_order.configuration.model_year)
      storage_order.configuration.variants = variants.find(variant => variant.id === storage_order.configuration.variants)
      storage_order.configuration.engine_transmission = engineTransmissions.find(engineTransmission => engineTransmission.id === storage_order.configuration.engine_transmission)
      storage_order.configuration.color = storage_order.configuration.variants.mappedColors.find(color => color.id === storage_order.configuration.color)
      setOrder(storage_order)

      return storage_order
    }

    return order
  }

  const loadLeasingPriceRanges = function (o, cet) {
    const currentLeasingPriceRange = o.leasing_price_range ?? null

    if (currentLeasingPriceRange === null) {
      return
    }

    const maybeCurrentLeasingPriceRange = currentLeasingPriceRanges.find(leasingPriceRange => leasingPriceRange.id === currentLeasingPriceRange.id)

    if (maybeCurrentLeasingPriceRange !== undefined) {
      return
    }

    currentEngineTransmissionLeasingPriceRangesLoop:
      for (const leasingPriceRanges of cet.leasing_price_ranges) {
        for (const leasingPriceRange of leasingPriceRanges) {
          if (leasingPriceRange.id === currentLeasingPriceRange.id) {
            setCurrentLeasingPriceRanges([ ...leasingPriceRanges ])
            break currentEngineTransmissionLeasingPriceRangesLoop
          }
        }
      }
  }

  const dealerData = function (o) {
    if (!isDealerConfigurator) {
      return
    }

    const validDealerNumbers = dealerNumberOptions.map(dealerNumberOption => dealerNumberOption.value)

    if (validDealerNumbers.length > 0 && !validDealerNumbers.includes(o.dealer_number)) {
      o.dealer_number = validDealerNumbers[0]
      setOrder(o)
    }
  }

  const loadColorImage = function (current_variant) {
    if (hasConfiguration) {
      return
    }

    const storage_color_image_id = storageGet(identifier, 'colorImageId')

    if (typeof storage_color_image_id === 'string' || typeof storage_color_image_id === 'number') {
      const color_options = current_variant?.steps?.[1]?.settings?.[colorSettingId]?.options ?? []
      for (let i = 0; i < color_options.length; i++) {
        if (color_options[i].id == storage_color_image_id) {
          setColorImage({ ...color_options[i] })

          break
        }
      }
    }
  }

  const setValidateSteps = function (o, cv) {
    if (cv === false || o === false) {
      return
    }

    setValidSteps(validateSteps(cv.steps, o))
  }

  const checkGuaranteePrice = function (o) {
    o.guarantee_price = null
    o.guarantee_price_car = null

    setOrder(o)
  }

  useEffect(() => {
    let cv = currentVariant
    let cet = currentEngineTransmission

    if (!hasConfiguration) {
      loadCurrentModelYear()
      cv = loadCurrentVariant()
      cet = loadCurrentEngineTransmission()
      loadExtraEquipments()
      loadChargings()
    }

    const o = loadOrder()

    if (o === false) {
      order.price = getCurrentPrice(order.paymentType, order, cv, cartItems)
      order.security_deposit = getSecurityDeposit(order.paymentType, order, cv, cet, cartItems)

      setOrder({ ...order })

      return // Don't use storage! Things have changed
    }

    loadLeasingPriceRanges(o, cet)
    dealerData(o)
    // TODO: Maybe set order 'o' price?
    loadColorImage(cv)
    setValidateSteps(o, cv ?? currentVariant)
    checkGuaranteePrice(o)

    o.price = getCurrentPrice(o.paymentType, o, cv, cartItems)
    o.security_deposit = getSecurityDeposit(o.paymentType, o, cv, cet, cartItems)

    setOrder({ ...o })

    setIsStorageOrderHandled(true)
  }, [])

  return <>{children}</>
}
